import React from 'react'

export default function ListItem(props) {
  return (
    <div className="conversation" onClick={() => props.openMessage(props.conversation)}>
      <img className="interlocutor-avatar" src={props.img} />

      <div className="text">
        <div className="user">{props.user}</div>
        <div className="user-message">{props.userMessage}</div>
      </div>

      <div className="conversation-date">{props.conversationDate}</div>

      <div className={props.unreadMessagesAmount ? 'conversation__new-messages' : 'hidden'}>{props.unreadMessagesAmount}</div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/components/Chat/listItem.js